import { type AxiosInstance } from 'axios';

import { HttpClient } from '../client/http-client';

import { axiosInstance } from '@utils/axios';

import { User } from './User';
import { Token } from './Token';
import { SbtTemplate } from './SbtTemplate';
import { Util } from './Util';
import { Sbt } from './Sbt';
import { PointToken } from './PointToken';
import { Dao } from './Dao';

const createApi = (axiosIntance?: AxiosInstance) => {
  const _httpClientInstance = new HttpClient({
    instance: axiosIntance,
  });

  const UserApi = new User(_httpClientInstance);
  const TokenApi = new Token(_httpClientInstance);
  const SbtTemplateApi = new SbtTemplate(_httpClientInstance);
  const Utilapi = new Util(_httpClientInstance);
  const SbtApi = new Sbt(_httpClientInstance);
  const PointApi = new PointToken(_httpClientInstance);
  const VoteApi = new Dao(_httpClientInstance);

  return {
    UserApi,
    TokenApi,
    SbtTemplateApi,
    Utilapi,
    SbtApi,
    PointApi,
    VoteApi,
  };
};

const CLIENT_API = createApi(axiosInstance);

export { CLIENT_API };
